import * as tslib_1 from "tslib";
import { IgrSectionHeaderCellInfo } from "./igr-section-header-cell-info";
import { TemplateSectionHeaderCellModel as TemplateSectionHeaderCellModel_internal } from "./TemplateSectionHeaderCellModel";
/**
 * Backing information for a template section header cell in the grid.
*/
var IgrTemplateSectionHeaderCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTemplateSectionHeaderCellInfo, _super);
    function IgrTemplateSectionHeaderCellInfo() {
        return _super.call(this) || this;
    }
    IgrTemplateSectionHeaderCellInfo.prototype.createImplementation = function () {
        return new TemplateSectionHeaderCellModel_internal();
    };
    Object.defineProperty(IgrTemplateSectionHeaderCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrTemplateSectionHeaderCellInfo;
}(IgrSectionHeaderCellInfo));
export { IgrTemplateSectionHeaderCellInfo };
//# sourceMappingURL=igr-template-section-header-cell-info.js.map
